import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';
import { RankingTable } from '@/components/Ranking/RankingTable';
import { season1RankingData } from '@/consts/season1RankingData.ts';

function ResultsPageSeason1() {
  return (
    <div className="h-svh max-w-full overflow-clip bg-linear-to-br from-indigo-600 via-purple-600 to-pink-600 grid place-items-center">
      <div className="container px-8 md:px-0 grid gap-24 place-items-center grid-auto-rows-max">
        <h1 className="text-2xl md:text-4xl font-bold text-white text-center">
          ランキング
        </h1>

        <RankingTable rankingData={season1RankingData} />

        <div>
          <Button asChild>
            <Link to="/">トップに戻る</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ResultsPageSeason1;
